import {
  dlqListResponseSchema,
  dlqRetryResponseSchema,
  type DlqListResponse,
  type DlqRetryResponse,
} from '@control-center/shared';

import { apiClient } from './api-client';

export interface DlqListParams {
  page?: number;
  pageSize?: number;
  channel?: 'whatsapp' | 'email';
}

export async function fetchDlq(params: DlqListParams = {}): Promise<DlqListResponse> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page ?? 1));
  qs.set('pageSize', String(params.pageSize ?? 25));
  if (params.channel) qs.set('channel', params.channel);
  const res = await apiClient.get<unknown>(`/api/admin/notifications/dlq?${qs.toString()}`);
  return dlqListResponseSchema.parse(res.data);
}

export async function retryDlqItem(id: string): Promise<DlqRetryResponse> {
  const res = await apiClient.post<unknown>(`/api/admin/notifications/dlq/${id}/retry`, {});
  return dlqRetryResponseSchema.parse(res.data);
}
